import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarAlert = ({ open, message, severity, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={10000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        top: '50% !important',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          direction: 'ltr',
          whiteSpace: 'pre-line'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
